"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revokeAccess = void 0;
const util_1 = require("../../util");
const util_2 = require("../../util");
const revokeAccess = async (address, cid, auth_token, revokeTo) => {
    if (!(0, util_2.isCidReg)(cid)) {
        return {
            isSuccess: false,
            error: "Invalid CID",
        };
    }
    try {
        const nodeId = [1, 2, 3, 4, 5];
        const nodeUrl = nodeId.map((elem) => `/api/setSharedKey/${elem}`);
        // send encryption key
        const data = await Promise.all(nodeUrl.map((url) => {
            return (0, util_1.API_NODE_HANDLER)(url, "DELETE", auth_token, {
                address,
                cid,
                revokeTo,
            });
        }));
        const temp = data.map((elem, index) => ({ ...elem, data: null }));
        return {
            isSuccess: (0, util_2.isEqual)(...temp),
            error: null,
        };
    }
    catch (err) {
        return {
            isSuccess: false,
            error: JSON.parse(err?.message),
        };
    }
};
exports.revokeAccess = revokeAccess;
